<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="退货单号" name='key_type'>
        <a-input style="width: 270px" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item label="退回仓库" name='refund_warehouse_id'>
        <a-select v-model:value="search.refund_warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered rowKey='refund_warehousing_sn' :columns='columns' :data-source='list'>
      <template #title_num>
        退货数量
        <a-tooltip placement='right'>
          <template #title>包装的最小单位数量</template>
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
      <template v-slot:action="{ record }">
        <a @click="()=> {$router.push('/antiFleeingGoods/backManage/backOrderDetails?type=channel&id='+record.refund_warehousing_sn)}"
          href="javascript:;">查看详情</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" />
  </a-card>
</template>
<script>
  import { InfoCircleOutlined } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import useTableSearch from "@/hooks/useTableSearch";
  import { getRefundOrderChannel,getWarehouseList } from "@/api/antiFleeing";
  const defSearch = {
    page: 1,
    limit: 10,
    keyword: "",
    refund_warehouse_id: "",
    start_time: "",
    end_time: ""
  };
  export default {
    components: {InfoCircleOutlined},
    setup() {
      const state = reactive({
        time: [],
        warehouseList:[]
      });
      let columns = [
        {
          title: "退货单号",
          dataIndex: "refund_warehousing_sn",
          key: "refund_warehousing_sn",
        },
        {
          title: "创建人",
          dataIndex: "create_role_name",
          key: "create_role_name",
        },
        {
          dataIndex: "return_quantity",
          key: "return_quantity",
          slots: { title: 'title_num' }
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "注备",
          dataIndex: "remark",
          key: "remark"
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data).catch(error => error);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        getWarehouse();
        tableHoosks.initData(getRefundOrderChannel, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime
      };
    },
  };
</script>